






import React from 'react';
import Calendar from './Calendar'; // Adjust the path if your Calendar component is in a different folder
 // Optional, for global styles if needed

function App() {
  return (
    <div className="App">
      
      <main>
        <Calendar />
      </main>
    </div>
  );
}

export default App;
